;(function( window, document, $, undefined ) {
  'use strict';

  var contact = (function() {

    var $private = {};
    var $public = {};

    $public.maps =function () {
      // Disable scroll zooming and bind back the click event
      var onMapMouseleaveHandler = function (event) {
        var that = $(this);

        that.on('click', onMapClickHandler);
        that.off('mouseleave', onMapMouseleaveHandler);
        that.find('iframe').css("pointer-events", "none");
      }

      var onMapClickHandler = function (event) {
        var that = $(this);

        // Disable the click handler until the user leaves the map area
        that.off('click', onMapClickHandler);

        // Enable scrolling zoom
        that.find('iframe').css("pointer-events", "auto");

        // Handle the mouse leave event
        that.on('mouseleave', onMapMouseleaveHandler);
      }

      // Enable map zooming with mouse scroll when the user clicks the map
      $('.maps.embed-container').on('click', onMapClickHandler);
    }

    $public.accordion = function() {
      var allQuestions = $('.dd-accordion > li > h2');

      allQuestions.on('click', function (){
        var thisElement = $(this);

        if(!thisElement.hasClass('active')){
          thisElement.addClass('active').next().stop().slideToggle();
          thisElement.find('.fa-chevron-up').css('display', 'block');
          thisElement.find('.fa-chevron-down').css('display', 'none');
        } else {
          thisElement.removeClass('active').next().stop().slideToggle();
          thisElement.find('.fa-chevron-up').css('display', 'none');
          thisElement.find('.fa-chevron-down').css('display', 'block');
        }

        return false;
      });
    };

    return $public;
  })();

  // Global
  window.contact = contact;
  contact.maps();
  contact.accordion();

})( window, document, jQuery );

$(window).load(function() {
});
